import reducer from "./reducer";
export { default as assetsDiscountsEntryByInstallments } from "./components/index";
export { default as assetsDiscountsEntryByInstallmentsReducerName } from "./constants";
export default reducer;
